module.exports = __webpack_public_path__ + "img/1482620539.8098885b.jpg";